<template>
  <UiContainer
    class="grid grid-cols-1 flex-wrap gap-6 gap-y-10 sm:grid-cols-2 md:grid-cols-3 md:gap-y-6"
  >
    <EventCardBigSkeleton
      v-for="card in 24"
      :key="'tile' + card"
      :class="{ 'md:col-span-1': card > 0 && !((card + 1) % 8) }"
    />
  </UiContainer>
</template>

<script setup lang="ts">
import { EventCardBigSkeleton } from '@/5_entities/Event'
import { UiContainer } from '@/6_shared/ui'
</script>
